import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import {
  ApplicationConfig,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
  inject,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  cookieInterceptor,
  requestErrorInterceptor,
  responseBodyInterceptor,
} from './core/interceptors';
import { BancardTokenService } from './core/services/bancard-token.service';
import { routes } from './app.routes';

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        cookieInterceptor,
        requestErrorInterceptor,
        responseBodyInterceptor,
      ]),
    ),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideAppInitializer(() => {
      const initializerFn = (
        (tokenService: BancardTokenService) => () =>
          tokenService.secureLogin()
      )(inject(BancardTokenService));
      return initializerFn();
    }),
  ],
};
